import { render, staticRenderFns } from "./ImportResultDetails.vue?vue&type=template&id=001da63d&scoped=true&"
import script from "./ImportResultDetails.vue?vue&type=script&lang=js&"
export * from "./ImportResultDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001da63d",
  null
  
)

export default component.exports